import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from "jquery";
import Vas from '../../Vas';
import CustomerData from '../vas/CustomerCard/CustomerData';
import CustomerPaymentData from '../vas/CustomerCard/CustomerPaymentData';
import CustomerDocumentData from '../vas/CustomerCard/CustomerDocumentData';
import CustomerContractData from '../vas/CustomerCard/CustomerContractData';
import CustomerLegalGuardianData from '../vas/CustomerCard/CustomerLegalGuardianData';
import CustomerCertificateData from '../vas/CustomerCard/CustomerCertificateData';

import '../../css/CustomerCard.css';

import { CustomerModel, RequestAjaxClass } from 'models-lib';
import { ClosePopUps } from 'utils-lib';

class CustomerCard extends Component
{
    //CustomerId = "";

    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.CurrentView = "CustomerData";
        this.CustomerId = props.match.params.id;
        this.GetRequest = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.CustomerModel = new CustomerModel([this]);
        this.state.Customer = {};
    }

    componentWillMount(){
      this.GetRequest.setApiUrl(Vas.ApiUrl);
      this.GetRequest.setApiKey(Vas.ApiKey);
      this.GetRequest.setAuth(true);
      this.CustomerModel.SetRequest(this.GetRequest);
      this.GetCustomer();
    }
    
    componentDidMount(){
        $("#HeaderTitle").html(Vas.Resources.Labels["Customer"]);
    }
    
    Update(observer){
      let role = localStorage.getItem("vas_role");

      if(role === "1"){
        this.setState({});
      } else if(role === "3" || role === "99"){
        let me = this;
        this.setState({},()=>{
          if(observer === "Customers"){
            if (this.CustomerModel.Customers)
            {        
                this.CustomerModel.Customers.forEach(function(value) {
                  me.setState({ Customer: value });
                  me.CustomerModel.Customer = value; 
                });
            }
          }
        });
      }
      
      $("#LoadingIcon").removeClass().addClass('hide');
  }

    GetCustomer(){
      let role = localStorage.getItem("vas_role");

      if(role === "1"){
        this.CustomerModel.GetCustomerById(this.CustomerId);
      } else if(role === "3" || role === "99"){
        var sendData = "?limit=10&start=0&customerCategory=Abo";
        this.CustomerModel.GetCustomers(sendData,null,null,"name1",null,"Abo",null,null,null,null,null,localStorage.getItem("Number_CurrentCustomer"),null,null,null); 
      }
    }

    openLoader(){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
    }

    GetCustomerData(){
        this.openLoader();
        let role = localStorage.getItem("vas_role");

        if(role === "1"){
          return (<CustomerData 
            id={this.CustomerId} 
            reference={this} />);
        }else if(role === "3" || role === "99"){
          return (<CustomerData 
            id={localStorage.getItem("Number_CurrentCustomer")} 
            reference={this} />);
        }
    }

    GetCustomerPaymentData(){
      let role = localStorage.getItem("vas_role");

      if(role === "1"){
        return (<CustomerPaymentData 
          id={this.CustomerId} 
          me={this} />);
      }else if(role === "3" || role === "99"){
        return (<CustomerPaymentData 
          id={localStorage.getItem("Id_CurrentCustomer")} 
          me={this} />);
      }
    }

    GetCustomerDocumentData(){

      let role = localStorage.getItem("vas_role");

      if(role === "1"){
        return (<CustomerDocumentData 
          id={this.CustomerId} 
          me={this} />);
      }else if(role === "3" || role === "99"){
        return (<CustomerDocumentData 
          id={localStorage.getItem("Id_CurrentCustomer")} 
          me={this} />);
      }
    }

    GetCustomerContractData(){

      let role = localStorage.getItem("vas_role");

      if(role === "1"){
        return (<CustomerContractData 
          id={this.CustomerId} 
          Name={this.CustomerModel.Customer.Name1 + '_' + this.CustomerModel.Customer.Name2} />);
      }else if(role === "3" || role === "99"){
        return (<CustomerContractData 
          id={localStorage.getItem("Id_CurrentCustomer")} 
          Name={this.CustomerModel.Customer.Name1 + '_' + this.CustomerModel.Customer.Name2} />);
      }
    }

    GetCustomerLegalGuardianData(){

      let role = localStorage.getItem("vas_role");

      if(role === "1"){
        return (<CustomerLegalGuardianData id={this.CustomerId} />);
      }else if(role === "3" || role === "99"){
        return (<CustomerLegalGuardianData id={localStorage.getItem("Id_CurrentCustomer")} />);
      }
    }

    GetCustomerCertificateData(){
      let role = localStorage.getItem("vas_role");

      if(role === "1"){
        return (<CustomerCertificateData id={this.CustomerId} />);
      }else if(role === "3" || role === "99"){
        return (<CustomerCertificateData id={localStorage.getItem("Id_CurrentCustomer")} />);
      }
    }

    GetView(nameOfView){

      if (this){
            ClosePopUps.close();
            
            this.DeselectTabs();

            switch (nameOfView){
                case "Data":
                    this.SelectTab("DataTabLink");
                    this.setState({ CurrentView: "CustomerData" });
                    break;
                case "Contract":
                    this.SelectTab("ContractTabLink");
                    this.setState({ CurrentView : "CustomerContractData" });
                    break;
                case "Payment":
                    this.SelectTab("PaymentTabLink");
                    this.setState({ CurrentView: "CustomerPaymentData" });
                    break;
                case "Document":
                    this.SelectTab("DocumentTabLink");
                    this.setState({ CurrentView: "CustomerDocumentData" });
                    break;
                case "LegalGuardian":
                    this.SelectTab("LegalGuardianTabLink");
                    this.setState({ CurrentView: "CustomerLegalGuardianData" });
                    break;
                case "Certificate":
                    this.SelectTab("CertificateTabLink");
                    this.setState({ CurrentView: "CustomerCertificateData" });
                    break;
                default:
                    this.SelectTab("DataTabLink");
                    this.setState({ CurrentView: "CustomerData" });
            }
        }
    }

    SelectTab(id){
        $("#"+id).removeClass().addClass("activeTab");
    }

    DeselectTabs()
    {
        $("#DataTabLink").removeClass().addClass("tab");
        $("#ContractTabLink").removeClass().addClass("tab");
        $("#PaymentTabLink").removeClass().addClass("tab");
        $("#DocumentTabLink").removeClass().addClass("tab");
        $("#LegalGuardianTabLink").removeClass().addClass("tab");
        $("#CertificateTabLink").removeClass().addClass("tab");
    }

    render()
    {
        let content = "";
        switch (this.state.CurrentView)
        {
            case "CustomerData":
                content = this.GetCustomerData(this.props.Id);
                break;
            case "CustomerContractData":
                content = this.GetCustomerContractData(this.props.Id);
                break;
            case "CustomerPaymentData":
                content = this.GetCustomerPaymentData(this.props.Id);
                break;
            case "CustomerDocumentData":
                content = this.GetCustomerDocumentData(this.props.Id);
                break;
            case "CustomerLegalGuardianData":
                content = this.GetCustomerLegalGuardianData(this.props.Id);
                break;
            case "CustomerCertificateData":
                content = this.GetCustomerCertificateData(this.props.Id);
                break;
            default: content = this.GetCustomerData(this.props.Id);
        }

        return (<div  >

          <table className="customerCard">
            <thead>
              <tr>
                <th 
                  className={"TitleRow"} 
                  style={{ verticalAlign: 'middle' }} 
                  colSpan={2}><img 
                    src={"../images/images.png"} 
                    style={{ width: 27, float: 'left' }} 
                    alt={"customerAvatar"} />
                  <div className={"customerCardTitle"}><b> {this.CustomerModel.Customer.Name1 + ", " + this.CustomerModel.Customer.Name2 }</b></div></th>
                <td style={{ width:'100px' }}><div 
                  id={"LoadingIcon"} 
                  className={'hide'}></div></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={"customerCardLinks"}>
                  <table>
                    <tbody>
                      <tr>
                        <td 
                          id={"DataTabLink"} 
                          className={"activeTab"} 
                          onClick={()=>{ this.GetView("Data"); }} >{Vas.Resources.Labels["CustomerData"]}</td>
                      </tr>
                      <tr>
                        <td 
                          id={"ContractTabLink"} 
                          className={"tab"} 
                          onClick={()=>{ this.GetView("Contract"); }}>{Vas.Resources.Labels["Contracts"]}</td>
                      </tr>
                      <tr>
                        <td 
                          id={"PaymentTabLink"} 
                          className={"tab"} 
                          onClick={()=>{ this.GetView("Payment"); }}>{Vas.Resources.Labels["MethodsOfPayment"]}</td>
                      </tr>
                      <tr>
                        <td 
                          id={"DocumentTabLink"} 
                          className={"tab"} 
                          onClick={()=>{ this.GetView("Document"); }}>{Vas.Resources.Labels["Documents"]}</td>
                      </tr>
                      <tr>
                        <td 
                          id={"CertificateTabLink"} 
                          className={"tab"} 
                          onClick={()=>{ this.GetView("Certificate"); }}>{Vas.Resources.Labels["Certificate"]}</td>
                      </tr>
                      <tr>
                        <td 
                          id={"LegalGuardianTabLink"} 
                          className={"tab"} 
                          onClick={()=>{ this.GetView("LegalGuardian"); }}>{Vas.Resources.Labels["LegalGuardian2"]}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td 
                  id={"tabContent"} 
                  style={{ verticalAlign: 'top', textAlign:'left' }} >{content}</td>
              </tr>
            </tbody>
          </table>
            
        </div>
        );
    }
}
export default CustomerCard;
